import React, { ReactElement } from 'react';
import { defineCustomElements as deckDeckGoHighlightElement } from '@deckdeckgo/highlight-code/dist/loader';
import styled from 'styled-components';
import { rem } from 'polished';
import { HTMLContent } from '../../components/Content';
import { Series } from './Series/Series';

deckDeckGoHighlightElement();

interface ArticleDesktopTemplateProps {
  content?: any;
  series: any;
  rightChildren: ReactElement;
  topChildren: ReactElement;
  children: ReactElement;
}

const StyledDesktopArticle = styled.div`
  .article-content-column-container {
    display: flex;
    width: 100%;
    text-align: left;
    margin-bottom: ${rem(`48px`)};
  }
  .article-content__left {
    flex: 0 1 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    color: ${({ theme }) => theme.colors.gray_3};
    &:last-child {
      margin-bottom: 0;
    }
    > div {
      margin-bottom: 0;
    }
  }
  .article-content__left-content {
    flex: 1 0 auto;
    padding: ${rem(`24px`)};
    padding-right: ${rem(`48px`)};
    border-radius: ${rem(`12px`)};
    background-color: ${({ theme }) => theme.colors.blue_1_65};
  }
  .article-content__seperator {
    flex: 1 0 48px;
  }
  .article-content__right {
    flex: 1 0 315px;
    position: relative;
    padding: ${rem(`24px`)};
    padding-left: ${rem(`48px`)};
    border-radius: ${rem(`12px`)};
    background-color: ${({ theme }) => theme.colors.blue_1_65};
    color: ${({ theme }) => theme.colors.gray_3};
  }
`;

export const ArticleDesktopTemplate = ({
  content,
  series,
  rightChildren = <div className="article-content__right" />,
  topChildren,
  children,
}: ArticleDesktopTemplateProps) => {
  return (
    <StyledDesktopArticle>
      {topChildren}
      <div>
        <div className="article-content-column-container">
          <div className="article-content__left">
            <div className="article-content__left-content">
              <slot user="wallE">
                <Series items={series} />
                <HTMLContent>{content}</HTMLContent>
                <Series items={series} />
              </slot>
            </div>
          </div>
          <div className="article-content__seperator" />
          {rightChildren}
        </div>
        {children}
      </div>
    </StyledDesktopArticle>
  );
};
